// extracted by mini-css-extract-plugin
module.exports = {"playArea":"shared_playArea__TraSt","header":"shared_header__3SWBl"};